/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';
import BetsExpandCollapse from '../../common/BetsExpandCollapse';
import Stats from '../../common/Stats';
import { getMatchStreamingProps, getStreamingId } from '../../data/streaming/streamingUtils';
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';
import { getLiveSportPathname } from '../../data/utils/getLiveSportPathname';
import { getLiveSportWindowLocationHash } from '../../data/utils/getLiveSportWindowLocationHash';
import { getMatchIdOrStageId } from '../../data/utils/getMatchIdOrStageId';
import { getStatsUrl } from '../../data/utils/getStatsUrl';
import { toggleFavouriteMatchInStorage } from '../../data/utils/toggleFavouriteMatchInStorage';
import { isWidgetEnabled, WidgetContext } from '../../data/widgets/WidgetContext';
import { labels } from '../../data/labels';
import { PrematchContext } from '../../prematch/Prematch';
import { LiveContext, StreamingContext } from '../Live';
import LiveMatchDropDown from './LiveMatchDropDown';

function LiveMatchHeader(props) {
    const conf = getConfiguration();
    const liveContext = React.useContext(LiveContext);
    const prematchContext = React.useContext(PrematchContext);
    const widgetContext = React.useContext(WidgetContext);
    const streamingContext = React.useContext(StreamingContext);
    const [dropdownToggled, setDropdownToggled] = useState(false);
    const [showStats, setShowStats] = useState(false);
    const widgetTemplate = getConfiguration()['wdgt'];

    const match = props.match;
    const widgetEnabled = isWidgetEnabled(match.sportRef);
    const streamingMap = getMatchStreamingProps(props.match);
    const streaming = streamingMap && streamingMap[props.match.id];
    const streamingId = getStreamingId(streaming);

    useEffect(() => {
        return () => {
            streamingContext.toggleStreamingId(null,null,null);
            widgetContext.setWidget({
                isWidgetToggleable: true,
                widgetMatchId: null,
                widgetContainerId: null
            });
        };
    }, []);

    useEffect(() => {
        if (liveContext == null) {
            return;
        }
        if (dropdownToggled) {
             document.querySelector("#main-wrapper").classList.add("popup-open");
        } else {
            document.querySelector("#main-wrapper").classList.remove("popup-open");
        }
     }, [dropdownToggled]);

     useEffect(() => {
        closeStreaming();
        if (widgetEnabled) {
            openWidgetMatch();
        }
     }, [match]);

    function handleGoBack() {
        if (liveContext) {
            liveContext.openLiveSuite(match.sportRef);
        } else {
            prematchContext.openTournament(prematchContext.tournament.uniqueId);
        }
    }

    function toggleStreaming() {
        if (isStreamingOpened()) {
            closeStreaming();
            openWidgetMatch();
        } else {
            closeWidgetMatch();
            streamingContext.toggleStreamingId(streaming,streamingId, match.id);
        }
    }

    function isStreamingOpened() {
        return streamingContext.streamingId === streamingId;
    }

    function closeStreaming() {
        streamingContext.toggleStreamingId(null,null,null);
        openWidgetMatch();
    }

    function openWidgetMatch() {
        if (widgetEnabled == null) {
            return;
        }
        widgetContext.setWidget({
            widgetSportId: match.sportRef,
            widgetStartCollapsed: true,
            widgetS5Layout: widgetTemplate,
            widgetGeniusId: match.geniusId,
            widgetLsportId: match.lsportWidgetId,
            widgetProviderType: match.widgetType,
            widgetMatchId: getMatchIdOrStageId(match),
            widgetContainerId: '#br_widget'
        });
    }

    function closeWidgetMatch() {
        widgetContext.setWidget({
            widgetMatchId: null,
            widgetContainerId: null
        });
    }

    function toggleDropdown() {
        setDropdownToggled(!dropdownToggled);
    }

    function toggleStats() {
        setShowStats(!showStats);
    }

    function toggleFavorite() {
        liveContext.toggleFavorite(match, props.aggregata);
        toggleFavouriteMatchInStorage(match.uniqueId, match, props.aggregata);
    }
    
    const fullDesc = match.team2 ? `${match.team1} - ${match.team2}` : match.team1;
    const isFavorite = liveContext && liveContext.favorites[match.uniqueId] !== undefined;

    return (
        <nav id="nav-go-back" className="nav-go-back">
            {/* {liveContext?
            <Link to={getLiveSportPathname()+getLiveSportWindowLocationHash(match.sportRef)} rel="nofollow" onClick={handleGoBack} >
                 <div className="arrow-container">
                    <div className="arrow arrow-left"></div>
                </div>
            </Link>
            :
            <div className="arrow-container" onClick={handleGoBack}>
                <div className="arrow arrow-left"></div>
            </div>
            } */}
            <div className="arrow-container" onClick={handleGoBack}>
                <div className="arrow arrow-left"></div>
            </div>
            {streamingId && !conf.lstwc && 
                <div className="live-tv-button" id="live-widget-switcher-button" onClick={toggleStreaming} >
                    <div className="live-tv-button-text">{labels['live.live_feed']}</div>
                </div>
            }
            {liveContext &&
                <div className={"fa fa-star fa-lg align-self-center ml-3 mr-3" + classIf(isFavorite, 'giallo')} onClick={toggleFavorite}></div>
            }
            <div className="title-container" id="live-title-container" onClick={toggleDropdown} >
                <div className="nav-section-title expandable" id="nav-section-title">
                    <div className="d-flex flex-column justify-content-center text-small">
                        <span>{match.team1}</span>
                        {match.team2 &&
                            <span>{match.team2}</span>
                        }
                    </div>
                </div>
            </div>
            <div className="arrow-container" id="stats-button" onClick={toggleStats}>
                <i className="fas fa-chart-bar"></i>
            </div>
            {showStats &&
                ReactDom.createPortal(<Stats url={getStatsUrl(match.id)} />, document.getElementById('stats-container'))
            }
            <BetsExpandCollapse/>
            {(props.tournaments && dropdownToggled) &&
                <LiveMatchDropDown desc={fullDesc} tournaments={props.tournaments} toggleDropdown={toggleDropdown} />
            }
        </nav>
    );
}

export default LiveMatchHeader;